import { useState, useCallback } from "react";
import {
    listTagsApi,
    createTagApi,
    updateTagApi,
    deleteTagApi
} from "../../services/tasksService";

export function useTaskTags({ token, workspaceId }) {
    const [tags, setTags] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchTags = useCallback(async () => {
        if (!workspaceId) return;
        setLoading(true);
        try {
            const data = await listTagsApi({ token, workspaceId });
            setTags(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error(err);
            setError("Failed to load tags.");
        } finally {
            setLoading(false);
        }
    }, [token, workspaceId]);

    const createTag = async (name, color) => {
        try {
            const newTag = await createTagApi({ token, workspaceId, data: { name, color } });
            setTags(prev => [...prev, newTag]);
            return newTag;
        } catch (err) {
            console.error("Failed to create tag");
            throw err;
        }
    };

    const updateTag = async (tagId, data) => {
        try {
            const updatedTag = await updateTagApi({ token, workspaceId, tagId, data });
            setTags(prev => prev.map(t => t.id === tagId ? updatedTag : t));
            return updatedTag;
        } catch (err) {
            console.error("Failed to update tag", err);
            throw err;
        }
    };

    const deleteTag = async (tagId) => {
        try {
            await deleteTagApi({ token, workspaceId, tagId });
            setTags(prev => prev.filter(t => t.id !== tagId));
        } catch (err) {
            console.error("Failed to delete tag", err);
            throw err;
        }
    };

    return {
        tags,
        loading,
        error,
        fetchTags,
        createTag,
        updateTag,
        deleteTag
    };
}
